module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-nescafe-block-1-07fd8e9f1a267c70425b2b1e6936ebea.jpg";